import React from "react";
import { Field } from "formik";
import { FieldButtonGroup } from "../../../components";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  clearFieldValues,
} from "../../../utils";
import EmployeeForm from "./EmployeeForm";
import EmployerForm from "./EmployerForm";

const BasicInformationForm = (props) => {
  const {
    fields,
    values,
    setValues,
    setErrors,
    isEdit,
    isSave,
    setFieldValue,
    handleChange,
    hasAdditionalRules,
    planId,
    deleteAdditionalAlloc,
    companyId,
  } = props;
  const onSourceTypeChange = (value) => {
    deleteAdditionalAlloc();
    const updatedValues = clearFieldValues({
      values,
      fieldsToExculde: [fields.sourceType, fields.isEarlyRetirement],
    });
    //if(value===1){setFieldValue([fields.isSafeHarbourMatch],false)};
    setValues({
      ...updatedValues,
      [fields.sourceType]: value,
      [fields.isNewContributionAllowed]: false,
      [fields.isDisplayToParticipantWebsite]: false,
      [fields.contributionType]: 1,
      [fields.isContributionManatory]: false,
      [fields.responsibleMode]: 1,
      [fields.isSafeHarbourMatch]: false,
      [fields.isMaximumLimitApplicable]: false,
      [fields.isIncludeDefferals]: false,
      [fields.isIncludePlanCompensation]: false,
      [fields.isLastDayRule]: false,
      [fields.isHoursRequirement]: false,
      [fields.hours]: null,
      [fields.isNormalRetirement]: false,
      [fields.isEarlyRetirement]: false,
      [fields.isDeath]: false,
      [fields.isDisability]: false,
    });
    setErrors({});
  };

  const isEmployee = parseInt(values[fields.sourceType], 10) !== 2;
  return (
    <div>
      <Field
        isRequired
        name={fields.sourceType}
        label="Source Type"
        options={toOptionValuesFromMapper(
          OPTIONS_DATA_MAPPER.SOURCES_FORM_TYPES
        )}
        selectedValue={values[fields.sourceType]}
        onChange={onSourceTypeChange}
        disabled={isEdit || isSave}
        size="smdd"
        component={FieldButtonGroup}
      />
      {isEmployee && (
        <EmployeeForm
          fields={fields}
          values={values}
          setErrors={setErrors}
          setFieldValue={setFieldValue}
          isEdit={isEdit}
          isSave={isSave}
          handleChange={handleChange}
          hasAdditionalRules={hasAdditionalRules}
          setValues={setValues}
          planId={planId}
          companyId={companyId}
          deleteAdditionalAlloc={deleteAdditionalAlloc}
        />
      )}
      {!isEmployee && (
        <EmployerForm
          fields={fields}
          values={values}
          setFieldValue={setFieldValue}
          setErrors={setErrors}
          isEdit={isEdit}
          isSave={isSave}
          handleChange={handleChange}
          hasAdditionalRules={hasAdditionalRules}
          setValues={setValues}
          planId={planId}
          companyId={companyId}
          deleteAdditionalAlloc={deleteAdditionalAlloc}
        />
      )}
    </div>
  );
};

export default BasicInformationForm;
